module.exports = __webpack_public_path__ + "img/comission.e2863291.svg";